import React from 'react'
import LanguageIcon from '@mui/icons-material/Language'
import CommentIcon from '@mui/icons-material/Comment'
import CheckIcon from '@mui/icons-material/Check'
import Tooltip from '@mui/material/Tooltip'
import {
  CenteredCard,
  IconCircle,
  HeaderGroup,
  Heading,
  Description,
  PrimaryButton,
  FeatureGrid,
  Feature,
  CheckIconCircle,
  FeatureTitle,
  FeatureDescription,
  HowItWorksTitle,
} from './styles'

type UnsupportedFeatureSplashProps = {
  title: string
  description: string
  onClick?: () => void
  buttonText?: string
  icon?: React.ReactElement
  features: Array<{ title: string; description: string }>
}

const UnsupportedFeatureSplash: React.FC<UnsupportedFeatureSplashProps> = ({
  title,
  description,
  onClick,
  buttonText = 'Talk to a Specialist',
  icon = <LanguageIcon sx={{ width: 64, height: 64, color: '#1B51A4' }} />,
  features,
}) => {
  return (
    <CenteredCard>
      <IconCircle>
        {icon}
      </IconCircle>

      <HeaderGroup>
        <Heading>{title}</Heading>
        <Description>{description}</Description>
      </HeaderGroup>

      {onClick && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip title='Schedule a Demo' arrow>
            <PrimaryButton
              variant='contained'
              onClick={onClick}
              startIcon={<CommentIcon sx={{ width: 20, height: 20 }} />}
            >
              {buttonText}
            </PrimaryButton>
          </Tooltip>
        </div>
      )}

      <div style={{ borderTop: '1px solid #E5E7EB', marginTop: '3rem', paddingTop: '2rem' }}>
      <HowItWorksTitle>How it works</HowItWorksTitle>

      <FeatureGrid>
        {features.map((feature, index) => (
          <Feature key={index}>
            <CheckIconCircle>
              <CheckIcon sx={{ width: 24, height: 24, color: '#32965D' }} />
            </CheckIconCircle>
            <FeatureTitle>{feature.title}</FeatureTitle>
            <FeatureDescription>{feature.description}</FeatureDescription>
          </Feature>
        ))}
      </FeatureGrid>
      </div>
    </CenteredCard>
  )
}

export default UnsupportedFeatureSplash
